import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/analytics';
import '../../../../queries/book-appointment.js';
import '../../../../queries/get-calendar-availability.js';
import '../../../../queries/get-time-slots.js';
import '../../../../queries/get-store-offer-by-code.js';
import '../../../../queries/get-user.js';
import '../../../../queries/get-store-opening-times.js';
import '../../../../queries/get-availability-stores-nearby.js';
import 'date-fns';
import '@grandvisionhq/stores-v2';
import '../../context/appointment-slots.js';
import { useAppointmentContext } from '../../context/AppointmentContext.js';
import '../../queries/get-book-appointment-store.js';
import '../../queries/get-book-appointment-type.js';
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from '../../utils.js';
import '../../../../components/AppointmentConfirmation/AppointmentConfirmation.js';
import '../../../../components/AppointmentCustomerForm/AppointmentCustomerFormContainer.js';
import '../../../../components/NoTimeSlots/types.js';
import 'classnames';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/common';
import '@grandvisionhq/auth';
import AppointmentLocationContainer from '../../../../components/AppointmentLocation/AppointmentLocationContainer.js';
import '@grandvisionhq/locations';
import '../../../../components/Navigation/steps.js';
import '../../../../components/StoreFinder/StoreFinderContainer.js';
import '../../../../components/ClientSessionManager/ClientSessionManager.js';
import { getBookAppointmentStore } from '../../data/book-appointment-store.js';
import { getBookAppointmentType } from '../../data/book-appointment-type.js';
import { InvalidVirtualAppointmentError, AlternativeUrlStoreError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError, AlternativeLinkedAppointmentTypeNotValidError } from '../../errors.js';

const WhereRoot = ()=>{
    const [, { type  }] = useAppointmentContext();
    return /*#__PURE__*/ React.createElement(AppointmentLocationContainer, {
        appointmentTypeId: type === null || type === void 0 ? void 0 : type.id
    });
};
WhereRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        let promises = [
            null,
            null,
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type,
                null,
                null, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale, formattedParams.tryInStoreFlow),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.linkedAppointmentTypeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.alternativeLinkedAppointmentTypeId, locale), 
            ];
        }
        const [store, type, linkedAppointmentType, alternativeLinkedAppointmentType] = yield Promise.all(promises);
        if (formattedParams.storeId && ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId))) {
            throw AlternativeUrlStoreError();
        } else if (formattedParams.storeId && !store) {
            throw StoreNotFoundError();
        } else if (formattedParams.typeId && !type) {
            throw TypeNotFoundError();
        } else if (store && type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !linkedAppointmentType) {
            throw LinkedAppointmentTypeNotValidError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.alternativeLinkedAppointmentTypeId) && !alternativeLinkedAppointmentType) {
            throw AlternativeLinkedAppointmentTypeNotValidError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: null
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { WhereRoot as default };
//# sourceMappingURL=WhereRoot.js.map
